import React from 'react';

import "./UnauthorisedUser.scss";


const UnauthorisedUser = () => (
    <div className="unauthorised-user-container">
        <span id="message">Access Denied</span>
        <p>To get access to the portal, please submit below request <br/>
        <a href="https://safeway.service-now.com/esc?id=sc_cat_item&sys_id=a55a5aec8769ae50a9df840e0ebb3511" target="_blank" rel="noopener noreferrer">EIoT User Access</a><br/>
        or contact <span>Self-Healing.Automation.Support@albertsons.com</span>
        </p>
    </div>
);

export default UnauthorisedUser;